export const labels = {
	rotate: {
		label: "Label.MobileCreator.BottomMenu.Photo.Rotate",
		default: "Rotate",
	},
};
